<template>
<div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
                <div class="swiper-wrapper">

                    <!--Portada General-->
                    <!--INICIO SLIDE-1--> 
                    <div class="swiper-slide fondoportada swiper-no-swiping" data-title="Elementos de contextualización / pág. 1">
                        
                        
                        <div class="container d-flex justify-content-center h-100">
                            <div class="row align-self-center justify-content-center">                                
                                
                                <div></div>
                                
                                <div class="col-lg-4 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                                    <div>
                                        <h3 class="text-center mb-4 color4Ppal">Creado por:</h3>
                                        <a href="https://www.itm.edu.co/" target="_blank"><img src="recursos/img/logo-itm-azul.png" class="img-fluid d-flex mx-auto mb-5 mb-lg-0" alt=""></a>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-12 col-sm-12 col-12 offset-lg-2 d-flex justify-content-center mt-lg-5 bordelogoini ml-0 pl-0">
                                    <a href="https://www.medellin.gov.co/" target="_blank"><img src="recursos/img/logo-alcaldia.png" class="img-fluid d-flex mx-auto pl-4" alt=""></a>                                   
                                </div>
                                <div class="row mt-5">
                                    <div class="col-12">
                                        <!-- <div class="d-none d-sm-none d-md-none d-lg-block mt-5"> -->
                                        <div class="mt-5">
                                            <img src="recursos/img/Linea-portada.png" class="img-fluid" alt="">
                                            <h3 class="mt-2 text-center pportada">www.itm.edu.co</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--INICIO SLIDE-1-->

                    <!--INICIO SLIDE-2-->
                    <div class="swiper-slide swiper-no-swiping portada" data-title="pág. 2">
                        <div class="p-conten">
                            <img src="recursos/img/INLIN_002.png" alt="" class="d-none d-md-block d-sm-none">
                            <img src="recursos/img/INLIN_002_cel.png" alt="" class="d-block d-md-none">
                            <div class="row">
                                <div class="col-lg-8 offset-lg-2">
                                    <h1 class="text-white">Unidad 1: Adquisición del lenguaje</h1>
                                    <hr class="lineaPortada">
                                    <h2 class="text-white">Introducción a la Lingüística</h2>
                                    <h3 class="text-white">Facultad de Artes y Humanidades</h3>
                                </div>
                            </div>
                            <h6 >Foto por Stevens en <a href="https://www.pexels.com/es-es/foto/escritorio-sentado-mesa-joven-4144101/" target="_blank" class="portadaEnlace">Unsplash</a> </h6>
                        </div>
                    </div>

                    <!--INICIO SLIDE-3-->
                    <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="pág. 3">
                        <div class="container-fluid">
                            <div class="row margen_principal">
                                <div class="col-12">
                                    <h2>Elementos de contextualización</h2><br>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12 col-12">
                                   
                                    <h3>Introducción</h3>
                                    <div>
                                        <p>El curso <span class="font-italic">Introducción a la Lingüística</span> del Instituto Tecnológico Metropolitano (ITM) es la primera asignatura del componente temático de lingüística para el programa Interpretación y Traducción Lengua de Señas Colombiana - Español. Su planteamiento reconoce cómo los análisis de la lingüística pasaron de considerar la lengua como un objeto de estudio histórico a establecerse dentro de un campo de la perspectiva estructural, lo que  implicó la definición de un método, un ámbito de estudio y la amplitud de panorama. Esto ha permitido establecer como finalidad clara de la lingüística el análisis de toda representación y manifestación de las lenguas naturales.</p>                                        
                                        <div class="text-right">
                                            <b-button @click="cambiaTextoVerMas" v-b-toggle.collapse-3 class="m-1 BtnPrincipal">{{botonVerMas.text}}</b-button>
                                        </div>
                                        
                                        <b-collapse id="collapse-3" class="mt-3">
                                            <p>En este sentido, el curso <span class="font-italic">Introducción a la Lingüística</span> se propone explicar el funcionamiento de las lenguas por medio de patrones que permiten relacionar los sistemas de cada una de ellas. A partir de lo anterior, se hace necesario conocer los principales paradigmas y puntos de quiebre que han determinado la historia de la lingüística y las diferentes rutas metodológicas que permiten el abordaje de los fenómenos discursivos, comenzado por el modelo prescriptivo, el cual formula una serie de reglas que intentan prescribir el uso de la lengua y comprende el carácter normativo de esta. En segundo lugar se encuentra el modelo de tipo descriptivo, que detalla desde el ángulo estructuralista cómo funciona el sistema de las lenguas, haciendo énfasis en la composición y caracterización de cada uno de sus componentes o niveles. En tercer lugar, se encuentra el modelo explicativo, que se esfuerza por la indagación y formulación de hipótesis sobre unas reglas constitutivas o “universales” generales para todas las lenguas.</p>
                                            <p>Esta ruta posibilitará la construcción de unas bases sólidas sobre el conocimiento lingüístico, como eje estructural en la formación disciplinar que un intérprete en LSC debe adquirir para la consolidación de las competencias exigidas por el entorno profesional.</p>
                                        </b-collapse>
                                    </div>                                                    
                                    
                                     <div class="Fondo1Ppal p-3 mt-4">
                                            <h3 class="text-white">Competencia</h3>
                                            <p class="text-white">Genera la apropiación conceptual de la evolución, tendencias y paradigmas en la lingüística a partir de los principios epistemológicos e históricos para el estudio y comprensión de los fenómenos de la lengua. Lo anterior permite construir herramientas metodológicas y estrategias que faciliten la resolución de problemas relacionados con los distintos niveles de la lengua y sus ámbitos de contexto.</p>
                                    </div>

                                </div>

                                <div class="col-lg-5 col-md-12 col-sm-12 col-12 offset-lg-1 mt-lg-0 mt-4">

                                    <h3 class="text-left mt-4">Indicadores de competencia</h3>
                                  
                                    <div class="accordion" role="tablist">
                                        <b-card no-body class="mb-1">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-1 class="btnColapsable">Reconoce</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                            <p>● Reconoce los principios de la psicolingüística para la explicación de la adquisición del lenguaje.</p>
                                            </b-card-body>
                                        </b-collapse>
                                        </b-card>

                                        <b-card no-body class="mb-0">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-2 class="btnColapsable">Plantea</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                            <p>● Plantea una noción sobre la adquisición del lenguaje desde una base sociocultural y/o biológica.</p>
                                            </b-card-body>
                                        </b-collapse>
                                        </b-card>

                                        <b-card no-body class="mb-0">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-3 class="btnColapsable">Explica</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                            <p>● Explica la construcción de la ontogenia del lenguaje y sus relaciones con áreas como la psicología y antropología.</p>
                                            </b-card-body>
                                        </b-collapse>
                                        </b-card>

                                        <b-card no-body class="mb-0">
                                        <b-card-header header-tag="header" class="p-0" role="tab">
                                            <b-button block v-b-toggle.accordion-4 class="btnColapsable">Analiza</b-button>
                                        </b-card-header>
                                        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                                            <b-card-body>
                                            <p>● Analiza con asertividad, desde las teorías, las diferencias entre la ontogenia y la filogenia del lenguaje.</p>
                                            </b-card-body>
                                        </b-collapse>
                                        </b-card>
                                    </div>

                                    <div class="row d-flex justify-content-center">
                                        <div class="col-md-5 col-xs-12 mt-5 d-flex align-items-center justify-content-center">
                                            <img src="recursos/img/GAVI/Aprendamos_Haciendo.png" class="img-fluid" alt="">
                                        </div>
                                        <div class="col-md-5 col-xs-12 Lineaizq1 mt-5">
                                            <div class="pl-2">
                                                <p>
                                                    <span class="font-weight-bold">Tiempo de estudio recomendado</span> <br>
                                                    Semanas 1, 2, 3 y 4
                                                </p>
                                                <p>
                                                    <span class="font-weight-bold">Área de conocimiento</span> <br>
                                                    Específica
                                                </p>
                                                <p>
                                                    <span class="font-weight-bold">Programa</span><br>
                                                    Interpretación y Traducción<br> Lenguaje de Señas Colombiana - Español
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <b-button v-b-modal.modal-redConceptos class="d-flex mx-auto mt-4 BtnPrincipal">Red de conceptos</b-button>
                                </div>

                                <ModalRed/>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'
import {Controles} from '../assets/RecursosITM/js/Controles'

import ModalRed from '@/components/Modales'

export default {
  name: 'Home',
  data: function(){
      return{
        botonVerMas: {
            text: 'Ver más'
        },
        seen: false
      };
  },
  components: {
    ModalRed
  },
  methods: {
    cambiaTextoVerMas: function(){
        if(this.seen){
            this.seen=false;
            this.botonVerMas.text="Ver más"
        }else{
            this.seen=true;
            this.botonVerMas.text="Ver menos"
        }
    }
  },
  mounted() {
        SwiperController(),
        document.title = this.$route.meta.title,
        Controles()
  }
}
</script>